'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

require('../../_commonjsHelpers-6ecf82ef.js');
var _extends = require('../../extends-733dd656.js');
var objectWithoutProperties = require('../../objectWithoutProperties-c6d3675c.js');
var React = require('react');
var index = require('../../index-7124f64c.js');
require('../../taggedTemplateLiteral-f923b98d.js');
var styled = require('styled-components');
require('../../xstyled-styled-components.es-6e2bde7d.js');
require('../../extends-5ede7877.js');
require('../../xstyled-prop-types.es-4220f7f4.js');
require('../../unsupportedIterableToArray-f175acfa.js');
require('../../breakpoints-ee0a4ae5.js');
require('../GlobalStyle/GlobalStyle.js');
require('../../utils/env/isTestEnv/isTestEnv.js');
require('../../utils/env/isBrowserEnv/isBrowserEnv.js');
require('../../utils/env/isProdEnv/isProdEnv.js');
require('../../utils/logger/logDeprecatedFeature/logDeprecatedFeature.js');
require('../../theme-80c5a73f.js');
require('../../polished.esm-8ddeb0a5.js');
require('../../colorBuilder-8c1a81a8.js');
require('../NuDSProvider/NuDSProvider.js');
require('../../slicedToArray-a8a77f0e.js');
require('../../utils/isType/isType.js');
require('../../defineProperty-3cad0327.js');
var styles_themeUtils = require('../../styles/themeUtils.js');
var components_Icon_Icon = require('../../Icon-efcd1bee.js');
require('../../styles/colors/colorVariantsShape.js');
require('../../utils/i18n/maybeFormatMessage.js');
require('../../utils/i18n/maybeFormatPrefixedMessage.js');
require('../../utils/intl/intlAriaAttrs.js');
require('../../utils/hooks/useIntlAriaAttrs.js');
require('../Typography/Typography.js');
var formik_esm = require('../../formik.esm-e131ccca.js');
require('../../utils/string/isString.js');
var validateField = require('../../validateField-372afc12.js');
var components_FieldErrorMessage_FieldErrorMessage = require('../FieldErrorMessage/FieldErrorMessage.js');
var FormContext = require('../../FormContext-74eaf8f0.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var styled__default = /*#__PURE__*/_interopDefaultLegacy(styled);

var Label = styled__default['default'].label.withConfig({
  displayName: "Label",
  componentId: "y5k36u-0"
})(["line-height:1.5;color:", ";display:block;position:relative;padding-left:32px;cursor:pointer;user-select:none;"], styles_themeUtils.nuDSColor('black', 'defaultT70'));
Label.displayName = 'Label';
var LabelText = styled__default['default'].span.withConfig({
  displayName: "Label__LabelText",
  componentId: "y5k36u-1"
})(["display:block;"]);
Label.displayName = 'LabelText';

var Checkmark = styled__default['default'].span.withConfig({
  displayName: "CheckboxInput__Checkmark",
  componentId: "sc-15ao3ov-0"
})(["position:absolute;top:2px;left:0;background-color:", ";color:", ";&:hover,&:focus{color:", ";}"], styles_themeUtils.nuDSColor('white', 'defaultT70'), styles_themeUtils.nuDSColor('black', 'defaultT70'), styles_themeUtils.nuDSColor('primary'));
Checkmark.displayName = 'Checkmark';
var CheckboxInput = styled__default['default'].input.withConfig({
  displayName: "CheckboxInput",
  componentId: "sc-15ao3ov-1"
})(["position:absolute;opacity:0;cursor:pointer;height:0;width:0;&:checked ~ ", ",&:hover ~ ", ",&:focus ~ ", "{color:", ";}"], Checkmark, Checkmark, Checkmark, styles_themeUtils.nuDSColor('primary'));
CheckboxInput.displayName = 'CheckboxInput';

var CheckboxWrapper = styled__default['default'].div.withConfig({
  displayName: "CheckboxWrapper",
  componentId: "iqksms-0"
})(["padding:1rem 0 3rem;"]);
CheckboxWrapper.displayName = 'CheckboxWrapper';
CheckboxWrapper.defaultProps = {
  hasValidation: false
};
CheckboxWrapper.propTypes = {
  hasValidation: index.propTypes.bool
};

var Checkbox = function Checkbox(_ref) {
  var id = _ref.id,
      label = _ref.label,
      name = _ref.name,
      syncValidations = _ref.syncValidations,
      onChange = _ref.onChange,
      className = _ref.className,
      props = objectWithoutProperties.objectWithoutProperties(_ref, ["id", "label", "name", "syncValidations", "onChange", "className"]);

  var validations = FormContext.useFormValidations();

  var _useContext = React.useContext(formik_esm.FormikContext),
      values = _useContext.values;

  var errorMessageId = "error-".concat(name);
  var labelId = "label-".concat(name);
  var isRequired = Boolean(syncValidations.required);
  return /*#__PURE__*/React__default['default'].createElement(formik_esm.Field, {
    name: name,
    validate: validateField.validateField(validations, syncValidations, values)
  }, function (_ref2) {
    var field = _ref2.field,
        meta = _ref2.meta;
    var handleOnChange = React.useCallback(function (event) {
      field.onChange(event);
      onChange(event);
    }, [field.onChange, onChange]);
    var hasError = Boolean(meta.error);
    var isTouched = Boolean(meta.touched);
    var isChecked = Boolean(field.value);

    var a11yProps = _extends._extends_1({
      'aria-required': isRequired,
      'aria-invalid': hasError,
      'aria-labelledby': labelId
    }, hasError && {
      'aria-describedby': errorMessageId
    });

    return /*#__PURE__*/React__default['default'].createElement(CheckboxWrapper, {
      className: className
    }, /*#__PURE__*/React__default['default'].createElement(Label, {
      htmlFor: id,
      id: labelId
    }, /*#__PURE__*/React__default['default'].createElement(CheckboxInput, _extends._extends_1({}, a11yProps, field, props, {
      checked: field.value,
      touched: isTouched,
      id: id,
      required: isRequired,
      type: "checkbox",
      onChange: handleOnChange
    })), /*#__PURE__*/React__default['default'].createElement(Checkmark, {
      "aria-checked": field.value,
      "aria-labelledby": "label-".concat(name),
      role: "checkbox"
    }, isChecked ? /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "checkbox-fill",
      title: "Checkbox filled",
      "aria-hidden": "true"
    }) : /*#__PURE__*/React__default['default'].createElement(components_Icon_Icon.Icon, {
      name: "checkbox",
      title: "Checkbox not filled",
      "aria-hidden": "true"
    })), /*#__PURE__*/React__default['default'].createElement(LabelText, null, label)), /*#__PURE__*/React__default['default'].createElement(components_FieldErrorMessage_FieldErrorMessage['default'], {
      name: name,
      errorMessageId: errorMessageId,
      message: meta.error
    }));
  });
};

Checkbox.defaultProps = {
  className: undefined,
  onChange: function onChange() {},
  syncValidations: {}
};
Checkbox.propTypes = {
  className: index.propTypes.string,
  id: index.propTypes.string.isRequired,
  label: index.propTypes.oneOfType([index.propTypes.string, index.propTypes.node]).isRequired,
  name: index.propTypes.string.isRequired,
  onChange: index.propTypes.func,
  syncValidations: index.propTypes.objectOf(index.propTypes.string)
};

exports.default = Checkbox;
//# sourceMappingURL=Checkbox.js.map
